import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import de from './de.json';
import fr from './fr.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
] as const;

export type LangCode = typeof SUPPORTED_LANGUAGES[number]['code'];

const stored = localStorage.getItem('2bf_lang') as LangCode | null;
const browserLang = navigator.language.slice(0, 2);
const validCodes = SUPPORTED_LANGUAGES.map(l => l.code) as string[];
const detected: LangCode = validCodes.includes(browserLang) ? (browserLang as LangCode) : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de }, fr: { translation: fr } },
    lng: stored ?? detected,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export function setLanguage(code: LangCode) {
  i18n.changeLanguage(code);
  localStorage.setItem('2bf_lang', code);
}

export default i18n;
